const state = [{
  name: "HTML(5)",
  img: "html5.png",
  category: "BASICS",
  year: 15
},
{
  name: "CSS(3)",
  img: "css.png",
  category: "BASICS",
  year: 15
},
{
  name: "JS",
  img: "js.png",
  category: "BASICS",
  year: 10
}];

const getters = {
  getSkills(state) {
    return state;
  },
  getSkillsByCategory(state) {
    return category => {
      return state.filter(x => {
        return x.category === category;
      });
    };
  }
};

export default {
  state,
  getters
};



// WEBPACK FOOTER //
// ./src/store/skills.js